// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__tbJwI","addWidgetButton":"Header_addWidgetButton__ibKmj","dashboardTabs":"Header_dashboardTabs__141lC","active":"Header_active__2W9pC"};